"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
/**
 * @description Primitive types aka, the primary types of data that the form elements can contain
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomFieldType = void 0;
var CustomFieldType;
(function (CustomFieldType) {
    CustomFieldType["STRING"] = "STRING";
    CustomFieldType["NUMBER"] = "NUMBER";
    CustomFieldType["DATE"] = "DATE";
    CustomFieldType["TIME"] = "TIME";
    CustomFieldType["BOOLEAN"] = "BOOLEAN";
    /**
     * This can be a list of String, Number or Boolean
     */
    CustomFieldType["PICK_LIST"] = "PICK_LIST";
    /**
     * This will be a number, but while rendering a currency symbol would be added as a prefix to the value
     */
    CustomFieldType["PRICE"] = "PRICE";
})(CustomFieldType = exports.CustomFieldType || (exports.CustomFieldType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3VzdG9tLWZpZWxkLXR5cGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY3VzdG9tLWZpZWxkLWNvbmZpZy90eXBlcy9jdXN0b20tZmllbGQtdHlwZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7Ozs7OztHQU1HO0FBQ0g7O0dBRUc7OztBQUVILElBQVksZUFjWDtBQWRELFdBQVksZUFBZTtJQUN6QixvQ0FBaUIsQ0FBQTtJQUNqQixvQ0FBaUIsQ0FBQTtJQUNqQixnQ0FBYSxDQUFBO0lBQ2IsZ0NBQWEsQ0FBQTtJQUNiLHNDQUFtQixDQUFBO0lBQ25COztPQUVHO0lBQ0gsMENBQXVCLENBQUE7SUFDdkI7O09BRUc7SUFDSCxrQ0FBZSxDQUFBO0FBQ2pCLENBQUMsRUFkVyxlQUFlLEdBQWYsdUJBQWUsS0FBZix1QkFBZSxRQWMxQiJ9